(function () {
  'use strict';
  var LIMIT = 10;
  var FABRIC_IDS = new Set(["44532730658915","44532730691683","44532730724451","44532730757219","44532733345891","44532733378659","44532733411427","44532733444195","44532733476963","44532733509731","44532733542499","44532733575267","44532737933411","44532737966179","44532737998947","44532738031715","44532738064483","44532738097251","44532738130019","44532738162787","44532738195555","44532738228323","44532738261091","44532738293859","44532738326627","44532738359395","44532738392163","44532738424931","44532738457699","44532738490467","44532738523235","44532738654307","44532738687075","44532738719843","44532738752611","44532738785379","44532738818147","44532738850915","44532738883683","44532738949219","44532738981987","44532739014755","44532739047523","44532739178595","44532739211363","44532739244131","44532739276899","44532739309667","44532739342435","44532739375203","44532739407971","44532739440739","44532739473507","44532739506275","44532739539043","44532739571811","44532739604579","44532739637347","44532739670115","44532739702883","44532739735651","44532739768419","44532740980835","44532741013603","44532741046371","44532741079139","44532741111907","44532741144675"]);
  var SAMPLE_IDS = new Set(["44539213381731","44539213414499","44539213447267","44539213480035","44539211579491","44539211612259","44539211645027","44539211677795","44539211350115","44539211382883","44539211415651","44539211448419","44539211907171","44539211939939","44539211972707","44539212005475","44539212038243","44539212071011","44539212726371","44539212759139","44539212791907","44539212824675","44539212857443","44539212890211","44539212922979","44539212955747","44539212988515","44539213021283","44539213054051","44539213086819","44539213119587","44539211481187","44539211513955","44539212202083","44539212234851","44539212267619","44539212300387","44539212333155","44539212365923","44539213316195","44539213676643","44539213250659","44539211022435","44539211546723","44539211710563","44539211743331","44539211776099","44539211808867","44539212103779","44539212136547","44539212169315","44539212398691","44539212431459","44539212464227","44539212496995","44539212529763","44539212562531","44539212628067","44539212660835","44539213185123","44539211841635","44539211874403","44539213742179","44539213774947","44539213807715","44539213545571","44539213578339","44539213611107"]);
  var nativeFetch = window.fetch.bind(window);

  function isSampleId(id) { return SAMPLE_IDS.has(String(id || '')); }
  function isFabricId(id) { return FABRIC_IDS.has(String(id || '')); }
  function sampleCount(cart) {
    return (cart.items || []).reduce(function (total, item) {
      return total + (isSampleId(item.variant_id) ? Number(item.quantity || 0) : 0);
    }, 0);
  }
  function announce(message, form) {
    var box = document.querySelector('[data-ss-sample-limit-message]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-ss-sample-limit-message', '');
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:12px 0;padding:12px 14px;border:1px solid #6f1d1b;color:#6f1d1b;background:#f4f0ea;font-size:13px;line-height:1.45;';
      (form || document.body).appendChild(box);
    }
    box.textContent = message;
    box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
  function fabricDenied(form) {
    announce('Fabric is sold with a two-yard minimum. Please select at least 2 yards.', form);
  }
  function denied(form) {
    announce('Sample orders are limited to 10 selections. Please remove a sample before adding another.', form);
  }
  function jsonResponse() {
    return new Response(JSON.stringify({ status: 422, message: 'Sample limit reached', description: 'Sample orders are limited to 10 selections.' }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    });
  }
  function readBody(body) {
    if (!body) return {};
    if (body instanceof FormData || body instanceof URLSearchParams) {
      var obj = {};
      body.forEach(function (value, key) { obj[key] = value; });
      return obj;
    }
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (e) {
        var params = new URLSearchParams(body), out = {};
        params.forEach(function (value, key) { out[key] = value; });
        return out;
      }
    }
    return body;
  }
  function checkAdd(data, cart) {
    var additions = [];
    if (Array.isArray(data.items)) additions = data.items;
    else additions = [{ id: data.id, quantity: data.quantity || 1 }];
    if (additions.some(function (item) { return isFabricId(item.id) && Number(item.quantity || 1) < 2; })) return 'fabric';
    var requested = additions.reduce(function (n, item) {
      return n + (isSampleId(item.id) ? Number(item.quantity || 1) : 0);
    }, 0);
    return sampleCount(cart) + requested <= LIMIT ? true : 'sample';
  }
  function checkChange(data, cart) {
    var line = Number(data.line || 0), quantity = Number(data.quantity || 0);
    if (!line || !cart.items || !cart.items[line - 1]) return true;
    if (isFabricId(cart.items[line - 1].variant_id) && quantity > 0 && quantity < 2) return 'fabric';
    if (!isSampleId(cart.items[line - 1].variant_id)) return true;
    return sampleCount(cart) - Number(cart.items[line - 1].quantity || 0) + quantity <= LIMIT ? true : 'sample';
  }
  function checkUpdate(data, cart) {
    var updates = data.updates || data;
    var total = 0;
    (cart.items || []).forEach(function (item, index) {
      var value = Array.isArray(updates) ? updates[index] : (updates[item.key] != null ? updates[item.key] : (updates[item.variant_id] != null ? updates[item.variant_id] : item.quantity));
      var qty = Number(value == null ? item.quantity : value);
      if (isFabricId(item.variant_id) && qty > 0 && qty < 2) total = LIMIT + 100;
      if (isSampleId(item.variant_id)) total += qty;
    });
    if (total > LIMIT + 50) return 'fabric';
    return total <= LIMIT ? true : 'sample';
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!/\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(url)) return nativeFetch(input, init);
    var action = (url.match(/\/cart\/(add|change|update)/) || [])[1];
    var data = readBody(init && init.body);
    return nativeFetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var allowed = action === 'add' ? checkAdd(data, cart) : (action === 'change' ? checkChange(data, cart) : checkUpdate(data, cart));
        if (allowed !== true) { if (allowed === 'fabric') fabricDenied(document.querySelector('form[action*="/cart"]')); else denied(document.querySelector('form[action*="/cart"]')); return jsonResponse(); }
        return nativeFetch(input, init);
      });
  };

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1 || form.dataset.ssSampleApproved === 'true') return;
    var idField = form.querySelector('[name="id"]');
    var quantityField = form.querySelector('[name="quantity"]');
    var id = idField && idField.value;
    var requestedQuantity = Number(quantityField && quantityField.value || 1);
    if (isFabricId(id) && requestedQuantity < 2) {
      event.preventDefault(); event.stopImmediatePropagation(); fabricDenied(form); return;
    }
    if (!isSampleId(id)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    nativeFetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var quantity = Number(quantityField && quantityField.value || 1);
        if (sampleCount(cart) + quantity > LIMIT) { denied(form); return; }
        form.dataset.ssSampleApproved = 'true';
        if (form.requestSubmit) form.requestSubmit(event.submitter || undefined); else form.submit();
        setTimeout(function () { delete form.dataset.ssSampleApproved; }, 1000);
      })
      .catch(function () { announce('We could not verify the sample limit. Please refresh and try again.', form); });
  }, true);
})();